export default {
  computed: {
    item() {
      return this.myOrder.productItem;
    },
    variants() {
      return this.item.variants;
    },
  },
  methods: {
    next(variant) {
      const item = this.item;
      item.price = parseFloat(variant.price);

      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
      this.$store.dispatch('SET_BULK_PRICE', null);
      this.$store.dispatch('SET_PRODUCT_ITEM', this.item);
      this.$store.dispatch('SET_PRODUCT_VARIANT_ID', variant.id);

      if (variant.pricelist_product_variants.length > 0) {
        this.$store.dispatch('SET_PRICELIST_PRODUCT_ID',
            this._.first(variant.pricelist_product_variants).id);
      }
      this.$store.dispatch('SET_ORDER_STEP', `${this._.first(
          this.orderStep.split('-'))}-${this.product.slug}-more-photos`);
    },
  },
};
